import { GatewayTaxonomie } from "@conformite/gateway";
import { userSession } from "@src/data/session/UserSession";

export class TaxonomieApi {
  static async getTaxonomie(): Promise<GatewayTaxonomie.TaxonomieResponse> {
    const { data } =
      await userSession.axiosInstance.get<GatewayTaxonomie.TaxonomieResponse>(
        "/taxonomie"
      );
    return data;
  }
}
